import ProductModal from "../components/product/Modals/ProductModal";
import ProductService from "./ProductService";
import { legacyAddToCart, legacyClearCart } from "../legacy";

function add(store, modal, sku, type, isProductVariant, details, quantity = 1) {
  var itemNumber = "";
  var scID = "";
  var productCAD = "";
  let productVariantCharacteritics = null;
  if (details && details.source === "triggeredfromcompatibleproduct") {
    itemNumber = details.skuCode;
    scID = details.skuId;
    productCAD = 0;
    productVariantCharacteritics = null;
  } else {
    if (sku) {
      itemNumber = sku.SkuCode;
      scID = sku.SitecoreId;
      productCAD = sku.Price != null ? sku.Price.RawPrice : 0;
      productVariantCharacteritics = isProductVariant
        ? getProductVariantCharacteritics(itemNumber)
        : null;
    }
  }
  const _showCartModal = ({ parentName, data, details }) => {
    if (parentName) {
      modal.hide(parentName);
    }
    const typeText = data.type == "quote" ? "quote" : "cart";
    const itemText = data.quantity == 1 ? "item" : "items";
    const cartModalTitle = `${data.quantity ??
      1} ${itemText} added to ${typeText}`;
    modal.show(
      ProductModal,
      {
        source: details ? details.source : null,
        skucode: details ? details.skuCode : null,
        skuId: details ? details.skuId : null,
        producttitle: details ? details.productTitle : null,
        productimage: details ? details.productImage : null,
        productimagealt: details ? details.productImageAlt : null,
        pricetext: details
          ? details.productPrice + " " + details.currencyCode
          : null,
        msrptext: details ? details.productMsrp : null,
        title: cartModalTitle,
        showCartModal: true,
        buttons: [
          {
            title: data.type == "quote" ? "Go to Quote" : "Go to Cart",
            class: "btn-primary",
            data: { quantity },
            handler: () => {
              window.location = "/cart";
            }
          },
          {
            title: "Stay Here"
          }
        ]
      },
      {
        adaptive: true,
        width: "840px",
        height: "auto",
        transition: "nice-modal-fade"
      }
    );
  }; // END _showCartModal

  const altType = type == "quote" ? "order" : "quote";
  const modalTitle =
    altType == "quote"
      ? '<i class="material-icons">report_problem</i>You already have a quote in progress'
      : '<i class="material-icons">report_problem</i>You already have an order in progress';

  const message =
    type == "quote"
      ? "You are only able to have either a quote or sales order active. Do you want to add this item to your sales order, or start a new quote instead?"
      : "You are only able to have either a quote or sales order active. Do you want to add this item to your current quote, or start a new sales order instead?";

  const _showMessageModal = _altType =>
    modal.show(
      ProductModal,
      {
        title: modalTitle,
        message: message,
        buttons: [
          {
            title:
              _altType == "quote"
                ? "Add to current quote"
                : "Start a new quote",
            data: { type: "quote", itemNumber, quantity, scID, productCAD },
            handler: ({ parentName }) => {
              if (_altType !== "quote") {
                _showCartModal({
                  parentName,
                  data: {
                    type: type,
                    itemNumber: itemNumber,
                    quantity: quantity,
                    scID: scID,
                    productCAD: productCAD
                  },
                  details
                });
                legacyClearCart(itemNumber, quantity, scID, productCAD, type);
                modal.hide(parentName);
                ProductService.ifFromRackShelfFinderPostDetails(this.store, {
                  type: "quote",
                  itemNumber,
                  quantity,
                  scID,
                  productCAD
                });
              } else {
                modal.hide(parentName);
                _showCartModal({
                  parentName,
                  data: {
                    type: _altType,
                    itemNumber: itemNumber,
                    quantity: quantity,
                    scID: scID,
                    productCAD: productCAD
                  },
                  details
                });
                legacyAddToCart(
                  itemNumber,
                  quantity,
                  scID,
                  productCAD,
                  _altType,
                  productVariantCharacteritics
                );
                ProductService.ifFromRackShelfFinderPostDetails(this.store, {
                  type: "quote",
                  itemNumber,
                  quantity,
                  scID,
                  productCAD
                });
              }
            }
          },
          {
            title:
              _altType == "quote"
                ? "Start a new sales order"
                : "Add to current order",
            data: { type: "order", itemNumber, quantity, scID, productCAD },
            handler: ({ parentName }) => {
              if (_altType == "quote") {
                _showCartModal({
                  parentName,
                  data: {
                    type: type,
                    itemNumber: itemNumber,
                    quantity: quantity,
                    scID: scID,
                    productCAD: productCAD
                  },
                  details
                });
                legacyClearCart(itemNumber, quantity, scID, productCAD, type);
                modal.hide(parentName);
                ProductService.ifFromRackShelfFinderPostDetails(store, {
                  type: "order",
                  itemNumber,
                  quantity,
                  scID,
                  productCAD
                });
              } else {
                modal.hide(parentName);
                _showCartModal({
                  parentName,
                  data: {
                    type: _altType,
                    itemNumber: itemNumber,
                    quantity: quantity,
                    scID: scID,
                    productCAD: productCAD
                  },
                  details
                });
                legacyAddToCart(
                  itemNumber,
                  quantity,
                  scID,
                  productCAD,
                  _altType,
                  productVariantCharacteritics
                );
                ProductService.ifFromRackShelfFinderPostDetails(store, {
                  type: "order",
                  itemNumber,
                  quantity,
                  scID,
                  productCAD
                });
              }
            }
          }
        ]
      },
      {
        adaptive: true,
        width: "640px",
        height: "auto",
        transition: "nice-modal-fade"
      }
    ); // END _showMessageModal
  const _addToCart = ({ parentName, data, details }) => {
    _showCartModal({
      parentName,
      data,
      details
    });
    legacyAddToCart(
      data.itemNumber,
      data.quantity,
      data.scID,
      data.productCAD,
      data.type,
      productVariantCharacteritics
    );
    // if rackshelf item from rackshelf finder post details
    ProductService.ifFromRackShelfFinderPostDetails(this.$store, data);
  }; // END _addToCart

  // let wecoCartCookie = JSON.parse(getCookie("WECO_cart"));
  //const url = `/ignitionapi/Account/GetBasketContents`;
  // Get Document Type
  let cartDocType = "";

  // Get the cart document Type in local storage
  const cart = document.getElementById("cart-local-storage");
  cartDocType = cart.getDocumentType();
  //cart.setDocumentType(cartDocumentType);
  //const config = {
  //headers: { Pragma: "no-cache" }
  //};
  //axios.get(url, config).then
  // (function (response) {
  //if (response.data != null && response.data.Content != null) {
  //cartDocType = response.data.Content.Prtyp;
  ///Logic moved here

  if (cartDocType != null && cartDocType !== "") {
    if (cartDocType == "203" && type == "order") {
      _addToCart({
        data: { itemNumber, quantity, scID, productCAD, type },
        details
      });
    } else if (cartDocType == "201" && type == "quote") {
      _addToCart({
        data: { itemNumber, quantity, scID, productCAD, type },
        details
      });
    } else {
      _showMessageModal(altType);
    }
  } else {
    _addToCart({
      data: { itemNumber, quantity, scID, productCAD, type },
      details
    });
  }
  // } else if (response.data != null && response.data.Status != null && response.data.Status.Message == "Basket empty") {
  //     _addToCart({
  //         data: { itemNumber, quantity, scID, productCAD, type }
  //         , details
  //     });
  // }
  // });
}

// function getCookie(cname) {
//   var name = cname + "=";
//   var decodedCookie = decodeURIComponent(document.cookie);
//   var ca = decodedCookie.split(";");
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) == " ") {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) == 0) {
//       return c.substring(name.length, c.length);
//     }
//   }
//   return "";
// }

function getProductVariantCharacteritics(itemNumber) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const make = urlParams.get("make") ? urlParams.get("make") : "";
  const model = urlParams.get("model") ? urlParams.get("model") : "";
  const item = {};
  item.IsProductVariant = true;
  item.ISPRODUCTVARIANTWITHCHARS = "Y";
  item.VARIANT_CHARACTERISTICS = [
    {
      KEY: "CATALOG_NUMBER",
      VALUE: itemNumber
    },
    {
      KEY: "RSH_MANUFACTURER",
      VALUE: make
    },
    {
      KEY: "RSH_MODEL",
      VALUE: model
    }
  ];
  return item;
}

export default {
  add
};
